import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { ADMIN_HOME } from '../../constants/routePathConstants';
import { useUserContext } from '../../contexts/UserContext';

/**
 * Gates the Workflow Builder route so direct navigation is blocked for users
 * without the WORKFLOW_BUILDER permission (see PERMISSIONS.WORKFLOW_BUILDER).
 * Mirrors the sidebar tab's visibility check (see requiresCanUseWorkflowBuilder in menu.js).
 */
export const WorkflowBuilderGuard = ({ redirectUrl = ADMIN_HOME }) => {
  const { canUseWorkflowBuilder } = useUserContext();

  if (!canUseWorkflowBuilder) {
    return <Navigate to={redirectUrl} replace />;
  }

  return <Outlet />;
};

export default WorkflowBuilderGuard;
